import React, { Component } from "react";
import { Admin, Resource} from "react-admin";
import { createMuiTheme } from '@material-ui/core/styles';

import FirmwareIcon from '@material-ui/icons/Memory';
import JobIcon from '@material-ui/icons/Assignment';

import AuthProvider from './Providers/AuthProvider';
import Dashboard from './Components/Dashboard';

import {FirmwareList, FirmwareCreate} from "./Components/Resources/Firmwares/FirmwareList";
import {HydrantList} from "./Components/Resources/Hydrants/HydrantList";
import {FirmwareJobList, FirmwareJobCreate} from "./Components/Resources/FirmwareJobs/FirmwareJobList";

import dataProvider from './Providers/DataProvider';

import theme from './Styles/theme.json';

const th = createMuiTheme(theme);

// const dataProvider = jsonServerProvider("https://jsonplaceholder.typicode.com");

class App extends Component {
  render() {
    return (
      <Admin 
        theme={th} 
        title='Hydrant Fleet Management' 
        dataProvider={dataProvider} 
        dashboard={Dashboard}
        authProvider = {AuthProvider}
        >
        <Resource name="hydrant" list={HydrantList} />
        <Resource name="firmwares" list={FirmwareList} create={FirmwareCreate} icon={FirmwareIcon}/>
        <Resource name="jobs" list={FirmwareJobList} create={FirmwareJobCreate} icon={JobIcon}/>
      </Admin>
    );
  }
}
export default App;